import asmoCharTable from './asmoCharTable'
import elyosCharTable from './elyosCharTable'

const letterIndex = (letter: string) => {
	return 'abcdefghijklmnopqrstuvwxyz'.indexOf(letter) + 1
}

export enum Race {
  ASMO = 'ASMO',
  ELYOS = 'ELYOS',
}

export enum Action {
  SPEAK_TO = 'SPEAK_TO',
  UNDERSTAND = 'UNDERSTAND',
}

export const MAX_LENGTH = 195

const translate = (input: string, outputLanguage: Race): string => {
	let tableIndex = 0
	let output = ''

	if (input.length > 195) {
		input = input.slice(0, 195)
	}

	input = input.toLowerCase()

	const table = outputLanguage === Race.ASMO ? asmoCharTable : elyosCharTable

	for (let i = 0; i < input.length; i += 1) {
		const index = letterIndex(input.charAt(i))
		if (index !== 0) {
			output = output.concat(table[tableIndex].char[index])
			tableIndex = table[tableIndex].next[index]
		} else {
			output = output.concat(input.charAt(i))
			tableIndex = 0
		}
	}

	return output
}

export default translate
